// extracted by mini-css-extract-plugin
module.exports = {"Messages":"Messages_Messages__2F07Y","NoMessages":"Messages_NoMessages__dq8Kg"};